import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input() bodyStyle: string;
  @Input() classes: any = [];

  ngOnInit(): void {
    this.classes = [...this.classes, 'card'].join(' ');
  }
}
